<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white">
      <v-toolbar-title>Bkash Cashout Disbursed</v-toolbar-title>
      <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keyup.enter="paginationMethod"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-text>
                    <v-card-title class="indigo white--text">
                      <div class="headline">
                        Coin Point & Transaction Details
                      </div>
                    </v-card-title>
                    <!-- <v-img
                      class="my-3"
                      contain
                      aspect-ratio="2"
                    >
                    
                      <v-layout
                        column
                        fill-height
                      >
                        <v-spacer></v-spacer>

                        <v-card-title class="gray--text pl-5 pt-5">
                          <div class="display-1 pl-5 pt-5"><span class="green--text">{{editedItem.name}}</span></div>
                        </v-card-title>
                      </v-layout>
                    </v-img> -->

                    <v-list two-line>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">phone</v-icon>
                          <!-- <v-icon color="indigo">mail</v-icon> -->
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ editedItem.phone }}
                          </v-list-tile-title>
                          <!-- <v-list-tile-title>{{editedItem.email}}</v-list-tile-title> -->
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-icon color="indigo" v-if="editedItem.active == 1">
                            radio_button_checked
                          </v-icon>
                          <v-icon color="indigo" v-else>
                            radio_button_unchecked
                          </v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>Active</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>

                      <v-divider inset></v-divider>
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="indigo">location_on</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>address</v-list-tile-title>
                          <v-list-tile-sub-title
                            v-if="editedItem.address != null"
                          >
                            {{ editedItem.address }}
                          </v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                    <v-card-title class="indigo white--text">
                      <div class="headline">Dasher Profile</div>
                    </v-card-title>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Total Coin
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.total_coin }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Total Point
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.total_point }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Ranking Level
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.level }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Ranking Name
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.rank_name }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Bkash Number
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.account_number }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Withdraw Amount
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.withdraw_amount }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Transaction Id
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.transaction_id }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Transaction Date
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.transaction_date }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Transaction Time
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          {{ editedItem.transaction_time }}
                        </v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs6>
                        <v-subheader class="black--text font-weight-regular">
                          Transaction Image
                        </v-subheader>
                      </v-flex>
                      <v-flex xs6 v-if="editedItem.trans_image">
                        <v-img
                          height="100%"
                          width="100%"
                          :src="
                            indexData.cashOutImageUrl + editedItem.trans_image
                          "
                        ></v-img>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-container>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="red" @click="close">Close</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="isLoaded">
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.dataset4.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataset4.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.dataset4.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.user_id }}</td>
          <td>{{ props.item.withdraw_amount }}</td>
          <td>{{ props.item.account_number }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.message }}</td>
          <td>{{ props.item.disbursed_by }}</td>
          <td>{{ props.item.disbursed_at }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataset4.from }} - {{ indexData.dataset4.to }} of
          {{ indexData.dataset4.total }}
        </template>
      </v-data-table>
      <!-- <template>
        <div class="text-xs-center">
          <v-pagination
            v-model="indexData.dataset4.current_page"
            :length="indexData.dataset4.last_page"
            @input="onPageChange"
          ></v-pagination>
        </div>
      </template> -->
      <template>
        <div class="text-xs-center">
          <v-layout wrap>
            <v-flex xs10 sm10 md10>
              <v-pagination
                right
                v-model="indexData.dataset4.current_page"
                :length="indexData.dataset4.last_page"
                @input="onPageChange"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </div>
      </template>
      <div>
        <v-btn
          v-if="indexData.dataset4.total"
          class="button"
          color="info"
          flat
          @click="download"
        >
          Click here to download disbursed list as excel
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import axios from "axios";
  import api from "./../../api/connectingUrls";
  import { saveAs } from "file-saver";
  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      menu: false,
      menu2: false,
      time: null,
      date: null,
      apiUrl: "withdraw-status-list",
      sl: 1,
      headers: [
        { text: "ID", align: "left", value: "id" },
        { text: "Dasher ID", align: "left", value: "user_id" },
        { text: "Withdraw Amount", align: "left", value: "withdraw_amount" },
        { text: "Bkash Number", value: "account_number" },
        { text: "Dasher Name", value: "name" },
        { text: "Message", value: "message" },
        { text: "Disbursed_by", value: "disbursed_by" },
        { text: "Disbursed_at", value: "disbursed_at" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      pagination: {
        rowsPerPage:10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {
        rowsPerPage:10,
      },
      transDocs: {
        transaction_id: "",
        transaction_date: "",
        transaction_time: "",
        trans_image: null,
      },
      valid: true,
      inputRules: [(v) => !!v || "This field is required"],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.dataset4) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      pagination() {
        this.onPageChange();
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.$store.dispatch("changeWithdrawStatus", [this.apiUrl, 4, "", 1, this.pagination.rowsPerPage]);
    },

    methods: {
      initialize() {
        this.paginationMethod();
      },
      async download() {
        const token = window.localStorage.getItem("datadash_token");
        var fileName = "Bkash-Disbursed-report" + new Date().toLocaleString();
        if (token != null) {
          await axios
            .get(`${api.rootUrl}/${"withdraw-export"}/${4}`, {
              file_name: fileName,
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              responseType: "blob",
            })
            .then((response) => {
              saveAs(response.data, fileName);
            });
        }
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      checkItem(item) {
        // console.log(item)
        this.editedIndex = this.indexData.dataset4.data.indexOf(item);
        this.editedItem = Object.assign([], item);
        this.dialog = true;
        // console.log(this.editedItem)
      },
      exportData() {
        // alert("test");
        this.$store.dispatch("exportData", ["withdraw-export", 4]);
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        // console.log(this.search)
        this.loading = true;

        if (this.search) {
          this.pagination.rowsPerPage=1000;
          this.$store.dispatch("changeWithdrawStatus", [this.apiUrl, 4, this.search, this.indexData.dataset4.current_page, this.pagination.rowsPerPage]);
          this.loading = this.indexData.dataset4.data ? false : true;
        } else {
          if(this.pagination.rowsPerPage==1000){
              this.pagination.rowsPerPage=10;
          }
          this.$store.dispatch("changeWithdrawStatus", [this.apiUrl, 4, this.search, this.indexData.dataset4.current_page, this.pagination.rowsPerPage]);
          this.loading = !this.indexData.dataset4.error ? false : true;
        }
        this.dialog = false;
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
